import React from "react";
import App from "./App";
import "./index.css";
import { createRoot } from "react-dom/client";

if (window.location.hostname.startsWith("www.")) {
  window.location = window.location.href.replace("www.", "");
}

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(<App />);